import React, { useState } from 'react'

import { Props } from './Form.types'

const Form: React.FC<Props> = ({
  submit,
  submitting
}) => {
  const [email, setEmail] = useState('')

  return (
    <form
      className="signup-form"
      onSubmit={(e) => {
        e.preventDefault()
        submit(email)
      }}
    >
      <div className="form-wrapper">
        <input
          required
          type="email"
          className="email-input"
          placeholder="your@email.com"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          aria-label="Email address"
        />
        <button
          className="submit-button"
          type="submit"
          disabled={submitting}
        >
          {submitting && <span className="spinner" />}
          {submitting ? 'Sending...' : 'Join the waiting list'}
        </button>
      </div>
    </form>
  )
}

export default Form
